module.exports = __webpack_public_path__ + "img/AT.9e8d26a2.svg";